module.exports = __webpack_public_path__ + "img/perfil_sway-back.37bc40d9.jpg";